import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'

export const SearchAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.search_results_page}
      onAccessDenied={() => {
        uiStore.changeRoute({ path: `/${ConversationRoutes.root}` })
      }}
    />
  )
})
